import { render, staticRenderFns } from "./RoomsWithoutFunctions.vue?vue&type=template&id=286c2ba6&"
import script from "./RoomsWithoutFunctions.vue?vue&type=script&lang=ts&"
export * from "./RoomsWithoutFunctions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports